import * as React from 'react';

import { getTranslation, keys } from '../../../Resources/Translations';
import TouchSwiper from '../../ReactComponents/TouchSwiper/TouchSwiper';
import { SelectedOption } from '../ProductFilters/SelectedOption';

interface SelectedOptionListProps {
    selectedOptions: SelectedOption[];
    onRemoveOption: (filterKey: string, subFilterKey: string | null, optionKey: string, isSelected: boolean) => void;
    onReset: () => void;
}

export const SelectedOptionList: React.FC<SelectedOptionListProps> = ({ selectedOptions, onRemoveOption, onReset }) => {
    const renderSelectedFilters = (selectedOptions: SelectedOption[]) => {
        return selectedOptions.map((selectedFilter, index) => {
            return (
                <li key={index}>
                    <button
                        className="SelectedOptionList__Button"
                        onClick={() => onRemoveOption(selectedFilter.filterKey, selectedFilter.subFilterKey, selectedFilter.optionKey, false)}
                    >
                        {selectedFilter.value}
                    </button>
                </li>
            );
        });
    };

    return (
        <ul className="SelectedOptionList">
            <TouchSwiper>
                {renderSelectedFilters(selectedOptions)}
                {selectedOptions.length > 1 && (
                    <li>
                        <button className="SelectedOptionList__ResetButton" onClick={() => onReset()}>
                            <span>{getTranslation(keys['selectedOptionList.removeAll'])}</span>
                        </button>
                    </li>
                )}
            </TouchSwiper>
        </ul>
    );
};
